// router/index.ts - Main Router Orchestration

import { setupLinkInterceptor } from "./linkInterceptor";
import { handleRouteChange } from "./navigation";
import {
	adjustBodyPaddingForFooter,
	handleAnchorScrollOnLoad,
} from "../utils/domHelpers";

/**
 * Initialize the client-side router
 * Sets up event listeners and handles initial page load
 */
export async function initializeRouter(): Promise<void> {
	// Set up link click interception
	setupLinkInterceptor();

	// Handle browser back/forward buttons
	setupHistoryListener();

	// Handle initial page load (if not already rendered by server)
	// Check if content has already been rendered
	const contentContainer = document.getElementById("content");
	const shouldRenderInitialRoute =
		contentContainer && contentContainer.innerHTML.trim() === "";

	if (shouldRenderInitialRoute) {
		await handleRouteChange();
	}

	// Handle anchor scrolling and footer adjustments
	handleAnchorScrollOnLoad("#content");
	adjustBodyPaddingForFooter();
}

/**
 * Set up listener for browser history changes (back/forward buttons)
 */
function setupHistoryListener(): void {
	window.addEventListener("popstate", async () => {
		await handleRouteChange();
		handleAnchorScrollOnLoad("#content");
		adjustBodyPaddingForFooter();
	});
}

/**
 * Clean up router event listeners (useful for testing or hot reload)
 */
export function cleanupRouter(): void {
	// This would require keeping references to handlers, which we can add if needed
	console.log("Router cleanup called");
}

// Re-export commonly used router functions for convenience
export { navigateTo, handleRouteChange } from "./navigation";
export { isClientSideRoute, getRoute } from "./routes";
